/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum MipState {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
}
